import api from '../../server';
import{decrypt,getCookie} from "../../utils"

export default {
  namespaced: true,
  state: {
    wechatwap:{},
    wechatscheme:getCookie("scheme") !== undefined&&getCookie("scheme") !== "" ? JSON.parse(decrypt(getCookie("scheme"))) : {},
    wechatauthor:getCookie("wechatauthor") !== undefined&&getCookie("wechatauthor") !== "" ? JSON.parse(decrypt(getCookie("wechatauthor"))) : {},
    payh5:{}
  },
  actions:{
    fetchWechatWap({commit}, {params}) {
      return api.WechatWap(params).then(data => commit('setWechatWap', {data}))
    },
    fetchWechatScheme({commit}, {params}) {
      return api.WechatScheme(params).then(data => commit('setWechatScheme', {data}))
    },
    fetchWechatPayH5({commit}, {params}) {
      return api.WechatPayH5(params).then(data => commit('setWechatPayH5', {data}))
    },
    fetchWechatOpenid({commit}, {params}) {
      return api.getOpenid(params).then(data => commit('setWechatOpenid', {data}))
    }
  },
  mutations: {
    setWechatWap(state,data){
      state.wechatwap = data.data.data
    },
    setWechatScheme(state,data){
      state.wechatscheme = data.data.data
    },
    setWechatOpenid(state,data){
      state.wechatauthor = data.data.data.openid?data.data.data:{}
    },
    setWechatPayH5(state,data){
      state.payh5 = data.data.data
    },
  }
}
